import { useParams } from 'react-router-dom';
import ArticleDetail from '../components/ArticleDetail.jsx';

export default function MediaArticlePage() {
  const { id } = useParams();
  return <ArticleDetail key={id} id={id} kind="media" />;
}
